import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  text: {
    marginBottom: '0.5rem',
    fontWeight: 600,
  },
});

const ProgressWithLabel = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box minWidth={35}>
        <Typography variant="h3" color="textSecondary" className={classes.text}>{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
    </Box>
  );
};

ProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default ProgressWithLabel;
